export default "/static/dashboard/build/app/img/v2/85946214317fd1dbc6923a0ddf85a3fa.png";